import { Controller } from "@hotwired/stimulus";
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";

export default class extends Controller {
  static targets = ["container"];
  static values = { content: String };

  connect() {
    this.children = this.containerTarget.children[0];

    if (this.children != null && this.#isFocusable(this.children)) {
      this.tooltipElement = this.children;
    } else {
      this.tooltipElement = this.containerTarget;
      this.containerTarget.tabIndex = 0; // Set the container to be focusable
    }

    this.tippyInstance = tippy(this.tooltipElement, { content: this.contentValue });
  }

  disconnect() {
    this.tippyInstance.destroy();
  }

  #isFocusable(element) {
    if (element == null) {
      return false;
    }

    const isFocusableTag = [
      "A",
      "BUTTON",
      "INPUT",
      "TEXTAREA",
      "SELECT",
      "AREA",
    ].includes(element.tagName);
    const hasTabIndex = element.tabIndex > -1;
    const hasContentEditable = element.isContentEditable;

    return isFocusableTag || hasTabIndex || hasContentEditable;
  }
}
